import { render, staticRenderFns } from "./foundation.vue?vue&type=template&id=5d03cfbb&"
import script from "./foundation.vue?vue&type=script&lang=js&"
export * from "./foundation.vue?vue&type=script&lang=js&"
import style0 from "./foundation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports